<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VGXuR0/tc-custom/9781421408392.jpg?1701634244499" alt="This image is the cover for the book Music in the Shadows"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Music in the Shadows
      </h1>
      <p class="bookDescription body article font2">
        <b>An analysis of Hollywood films that blend elements of musicals and film noir, from the author of <i>Blackout: World War II and the Origins of Film Noir</i>.</b><br/><br/>Welcome to the world of “noir musical” films, where tormented antiheroes and hard-boiled musicians battle obsession and struggle with their music and ill-fated love triangles. Sultry divas dance and sing the blues in shrouded nightclubs. Romantic intrigue clashes with backstage careers.<br/><br/>In her pioneering study, <i>Music in the Shadows</i>, film noir expert Sheri Chinen Biesen explores musical films that use film noir style and jazz to inhabit a disturbing underworld and reveal the dark side of fame and the American Dream. While noir musical films like <i>A Star Is Born</i> (1954) include musical performances, their bleak tone and expressionistic aesthetic more closely resemble the visual style of film noir. Their narratives unfold behind a stark noir lens: distorted, erratic angles and imbalanced hand-held shots allow the audience to experience a tortured, disillusioned perspective.<br/><br/>While many musicals glamorize the quest for the Hollywood spotlight, brooding noir musical films such as <i>Blues in the Night</i>,<i> Gilda</i>,<i> The Red Shoes</i>,<i> West Side Story</i>, and <i>Round Midnight</i> stretch the boundaries of film noir and the musical as film genres collide. Deep shadows, dim lighting, and visual composition evoke moodiness, cynicism, pessimism, and subjective psychological points of view.<br/><br/>Biesen draws on extensive primary research in studio archives to situate her examination within a historical, industrial, and cultural context.<br/><br/><b>“Biesen builds a fascinating and quite convincing case for a genre hybrid, the noir musical, that took root in the 1940s but has continued to evolve ever since.” —Thomas Schatz, The University of Texas at Austin</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sheri Chinen Biesen
      </h2>
      
      <p class="authorDescription body article">Sheri Chinen Biesen is an associate professor of radio, television, and film studies at Rowan University and author of Blackout: World War II and the Origins of Film Noir, also published by Johns Hopkins.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7df9396f